// Generated by purs version 0.15.15
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_SectionFeedback from "../Ouroboros.Models.Brands.SectionFeedback/index.js";
import * as Ouroboros_Models_Core_ErrorHandlers from "../Ouroboros.Models.Core.ErrorHandlers/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Services_Clients_Interop_IO from "../Ouroboros.Services.Clients.Interop.IO/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
var DocumentRefineAction = function (x) {
    return x;
};
var unhandledContentFailure = {
    message: /* #__PURE__ */ Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Document Synthesis Operations are currently unavailable. Please try again later or contact support if the issue persists."),
    info: /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
};
var toLoadingErrorInput = function (errorValue) {
    var statusCode = (function () {
        if (errorValue.statusCode instanceof Data_Maybe.Nothing) {
            return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
        };
        if (errorValue.statusCode instanceof Data_Maybe.Just) {
            return Ouroboros_Services_Clients_Interop_Option.some(errorValue.statusCode.value0);
        };
        throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.DocumentRefine (line 135, column 7 - line 137, column 40): " + [ errorValue.statusCode.constructor.name ]);
    })();
    var message = Ouroboros_Models_Core_ErrorHandlers.contentErrorMessage({
        type: errorValue.type,
        message: errorValue.message,
        statusCode: statusCode
    });
    return {
        message: message.message,
        info: message.info
    };
};
var runRefineSection = function (v) {
    return function (documentId) {
        return function (request) {
            return v(documentId)(request);
        };
    };
};
var runNavigate = function (v) {
    return function (path) {
        return v(path);
    };
};
var runLoadingAction = function (v) {
    return v;
};
var runUpdateSectionSuccess = function (env) {
    return function (documentId) {
        return function (updatedSection) {
            return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(env.updateSection)(updatedSection), runNavigate(env.navigate)(Ouroboros_Programs_Capabilities.runRouteBuilder(env.reviewRoute)(documentId)), runLoadingAction(env.loading.setSuccess) ]);
        };
    };
};
var runDocumentRefineAction = function (v) {
    return v;
};
var readOption = function (v) {
    return v;
};
var mkDocumentRefineAction = DocumentRefineAction;
var missingDocumentError = {
    message: /* #__PURE__ */ Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Document is not loaded. Return to review and try again."),
    info: /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
};
var handleSuccess = function (env) {
    return function (documentId) {
        return function (response) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(runUpdateSectionSuccess(env)(documentId)(response.updated_section));
        };
    };
};
var handleContentError = function (env) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(toLoadingErrorInput(errorValue))));
    };
};
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/document_refine_controller.md";
var buildRequest = function (section) {
    return function (feedback) {
        return {
            feedback: Ouroboros_Models_Brands_SectionFeedback.makeSectionFeedback(feedback),
            section_id: section.metadata.id
        };
    };
};
var runSubmissionTask = function (env) {
    return function (documentId) {
        return function (section) {
            return function (feedback) {
                return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                    return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleContentError(env))(handleSuccess(env)(documentId))(runRefineSection(env.refineSection)(documentId)(buildRequest(section)(feedback)));
                })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
            };
        };
    };
};
var submitRefineTask = function (env) {
    return function (feedback) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(missingDocumentError)));
        })(function (document) {
            return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(unhandledContentFailure)));
            })(function (section) {
                return runSubmissionTask(env)(document.id)(section)(feedback);
            })(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.mostRecentSection)));
        })(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.document)));
    };
};
var mkDocumentRefineController = function (env) {
    return {
        submit: function (feedback) {
            return mkDocumentRefineAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(submitRefineTask(env)(feedback)));
        }
    };
};
export {
    DocumentRefineAction,
    mkDocumentRefineController,
    runDocumentRefineAction,
    documentationPath
};
//# sourceMappingURL=index.js.map
